// components/MonthSelector/MonthSelector.js
import React from "react";
import { Form } from "react-bootstrap";
import { getAvailableYears, getAvailableMonths } from "../../utils/facturationUtils";

function MonthSelector({ activeTabs, selectedMonth, setSelectedMonth, toast }) {
  const availableYears = getAvailableYears(activeTabs);
  const availableMonths = getAvailableMonths(activeTabs, selectedMonth);

  return (
    <Form.Group className="d-flex gap-3 mb-3 mt-3">
      <Form.Select
        value={selectedMonth?.split("-")[1] || ""}
        onChange={(e) => {
          const selectedYear = e.target.value;
          const monthsForYear = activeTabs.filter((m) =>
            m.endsWith(`-${selectedYear}`)
          );
          if (monthsForYear.length > 0) {
            const currentMonth = selectedMonth?.split("-")[0];
            const fallback =
              monthsForYear.find((m) => m.startsWith(currentMonth)) ||
              monthsForYear[0];
            setSelectedMonth(fallback);
          } else {
            toast.info("Aucune facturation pour cette année.");
          }
        }}
      >
        {availableYears.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </Form.Select>

      <Form.Select
        value={selectedMonth?.split("-")[0] || ""}
        onChange={(e) => {
          const selectedMonthName = e.target.value;
          const currentYear = selectedMonth?.split("-")[1];
          const newMonthYear = `${selectedMonthName}-${currentYear}`;
          if (activeTabs.includes(newMonthYear)) {
            setSelectedMonth(newMonthYear);
          } else {
            toast.info("Aucune facturation pour ce mois-année.");
          }
        }}
      >
        {availableMonths.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}

export default MonthSelector;
